const PREFIX = 'AUTH';

export const AUTH_LOGIN_SSO = `${PREFIX}/LOGIN_SSO`;
export const AUTH_LOGOUT = `${PREFIX}/LOGOUT`;
export const AUTH_REFRESH_TOKEN = `${PREFIX}/REFRESH_TOKEN`;
export const AUTH_CHECK_SESSION = `${PREFIX}/CHECK_SESSION`;
